module.exports = __webpack_public_path__ + "static/media/KUZMA CAR-40.ae5a9935.png";